'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Works = require('./Works.css');

var _Works2 = _interopRequireDefault(_Works);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Works = (_dec = (0, _reactCssModules2.default)(_Works2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Works, _Component);

  function Works(props) {
    (0, _classCallCheck3.default)(this, Works);
    return (0, _possibleConstructorReturn3.default)(this, (Works.__proto__ || (0, _getPrototypeOf2.default)(Works)).call(this, props));
  }

  (0, _createClass3.default)(Works, [{
    key: 'render',
    value: function render() {
      var iconOne = require('../../../static/images/icons_step1.svg');
      var iconTwo = require('../../../static/images/icons_step2.svg');
      var iconThree = require('../../../static/images/icons_step3.svg');
      var iconFour = require('../../../static/images/icons_step4.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'works-wrap' },
        _react2.default.createElement(
          _.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'works-title' },
            'How to align your investments with your values'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'works-steps-photos' },
            _react2.default.createElement(
              'div',
              { styleName: 'works-steps' },
              _react2.default.createElement(
                'div',
                { styleName: 'works-step' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-img-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '1'
                  ),
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step one icon',
                    src: iconOne
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step-info' },
                  _react2.default.createElement(
                    _.Link,
                    { to: _config2.default.routes.list, title: 'Search funds | Deforestation Free Funds' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'wht' },
                      'Search for mutual funds and ETFs'
                    )
                  ),
                  ' by name, ticker, or asset manager. We have thousands of the most commonly held U.S. mutual funds in our database.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'works-step' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-img-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '2'
                  ),
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step two icon',
                    src: iconTwo
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step-info' },
                  'See how much money your funds have invested in deforestation - whether in agricultural commodity producers and traders, the banks who finance them, or the brands who use those commodities in their products.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'works-step' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-img-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '3'
                  ),
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step three icon',
                    src: iconThree
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step-info' },
                  _react2.default.createElement(
                    _.Link,
                    { to: _config2.default.routes.list, title: 'Search funds | Deforestation Free Funds' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'wht' },
                      'Look in our database'
                    )
                  ),
                  ' for fund options with lower levels of investment in deforestation-risk companies.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'works-step' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-img-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '4'
                  ),
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step four icon',
                    src: iconFour
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step-info' },
                  'If you have a financial advisor or retirement plan manager, show them these results. Ask them to assist you in aligning your investments with your values.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Works;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = Works;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Works/Works.js
// module id = 1326
// module chunks = 0